'use strict';

import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle';
import { showToast } from '../../utils/ShowToast';
import { isParcelPage, initBootstrapComponents, translations as t } from '../../parcel/parcel-page';
import { Widgets } from '../../widgets/registry';
import { Modals } from '../../utils/Modals';

const clientsByFilter = {};

const $grid = () => $('.datagrid').first();

const gridParamPrefix = () => $('[data-grid-param-prefix]').first().data('gridParamPrefix');

function gridSignalUrl(link, extraParams = {}) {
  const url = new URL(link, window.location.origin);

  Object.entries(extraParams).forEach(([key, value]) => url.searchParams.set(key, value));

  const prefix = gridParamPrefix();

  if (prefix) {
    for (const [key, value] of new URL(window.location.href).searchParams.entries()) {
      if (key.startsWith(prefix)) {
        url.searchParams.set(key, value);
      }
    }
  }

  return url.toString();
}

const pad2 = (value) => String(value).padStart(2, '0');

// `toISOString()` would return the previous day for the night shift
const localDateValue = (date) => `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;

const localTimeValue = (date) => `${pad2(date.getHours())}:${pad2(date.getMinutes())}`;

function rememberBranchInUrl(branchId) {
  const url = new URL(window.location.href);
  url.searchParams.set('branchId', branchId);
  window.history.replaceState(null, '', url.toString());
}

function destroySelect2($select) {
  if ($select.hasClass('select2-hidden-accessible')) {
    $select.select2('destroy');
  }
}

function setBranchSelectorOption(branchId, branchName) {
  const $selector = $('#branch-selector');
  destroySelect2($selector);
  $selector
    .empty()
    .append(new Option('(#' + branchId + ') ' + branchName, branchId, true, true))
    .trigger('change');
}

function updateTabLinks(branchId) {
  $('#parcelTabs a.nav-link').each(function () {
    const url = new URL($(this).attr('href'), window.location.origin);

    if (branchId && String(branchId) !== '0') {
      url.searchParams.set('branchId', branchId);
    } else {
      url.searchParams.delete('branchId');
    }

    $(this).attr('href', url.toString());
  });
}

function initializeFilters() {
  Widgets.init();
}

function renderSelectedClients(filterId) {
  const $container = $('#' + filterId + '-selected-clients');
  const $trigger = $('.js-client-search-trigger[data-filter-id="' + filterId + '"]');
  const clients = clientsByFilter[filterId] || [];

  // '[]' would count as an active filter in the grid state, an empty selection must clear the field
  $('#' + filterId + '-client-ids').val(clients.length > 0 ? JSON.stringify(clients) : '');
  $trigger.toggleClass('active', clients.length > 0);

  if (clients.length > 0) {
    $('#' + filterId + '-client').prop('checked', true);
  }

  $container.empty();

  clients.forEach((client) => {
    $container.append(
      $('<span>').addClass('client-tag btn btn-outline-danger btn-sm').append(
        $('<span>').text(client.text),
        $('<span>')
          .addClass('remove-client')
          .attr('data-client-id', client.id)
          .append($('<i>').addClass('fa fa-trash'))
      )
    );
  });
}

function readClientsFromFilter($scope) {
  const $input = $scope.find('.js-selected-client-ids');
  const filterId = $scope.find('.parcel-type-filter .js-client-search-trigger').data('filter-id');

  if (!$input.val() || !filterId) {
    return;
  }

  try {
    clientsByFilter[filterId] = JSON.parse($input.val());
  } catch (e) {
    showToast('error', t.error, String(e.message));
    return;
  }

  renderSelectedClients(filterId);
}

const restoreClientFilter = () => readClientsFromFilter($('.tab-pane.active'));

function reloadGrid(url, onSuccess) {
  $.addDatagridSpinner($grid());

  $.nette.ajax({
    url: url,
    success: function (payload) {
      if (onSuccess) {
        onSuccess(payload);
      }

      setTimeout(function () {
        restoreClientFilter();
        initializeFilters();
        $.removeDatagridSpinner();
      }, 100);
    },
    error: function () {
      $.removeDatagridSpinner();
      showToast('error', t.error, t.connectionFailed);
    },
  });
}

(function () {
  if (window.__parcelDatagridInitialized === true) {
    return;
  }
  window.__parcelDatagridInitialized = true;

  $(function () {
    if (!isParcelPage()) return;

    $(document).on('ajaxComplete', function () {
      $('[data-toggle="tooltip"]').each(function () {
        const existing = bootstrap.Tooltip.getInstance(this);
        if (existing) existing.dispose();
        new bootstrap.Tooltip(this);
      });
    });

    $('.tab-pane').each(function () {
      readClientsFromFilter($(this));
    });

    const $branchSelector = $('#branch-selector');

    const currentUrl = new URL(window.location.href);
    if (!currentUrl.searchParams.has('branchId')) {
      const branchId = $branchSelector.val();
      if (branchId && branchId !== '-1') {
        currentUrl.searchParams.set('branchId', branchId);
      }
    }
    window.history.replaceState(null, '', currentUrl.toString());

    initializeFilters();
    updateTabLinks($branchSelector.val());

    $branchSelector
      .off('select2:select.parcel')
      .on('select2:select.parcel', function (e) {
        const branchId = e.params.data.id;

        reloadGrid(gridSignalUrl($(this).data('ajax-handler'), { branchId: branchId }), function () {
          rememberBranchInUrl(branchId);
          updateTabLinks(branchId);
        });
      });

    $('.js-reset-branch')
      .off('click.parcel')
      .on('click.parcel', function () {
        reloadGrid(gridSignalUrl($(this).data('reset-url')), function (payload) {
          if (!payload.defaultBranchId) return;

          rememberBranchInUrl(payload.defaultBranchId);

          if (payload.resetBranch) {
            setBranchSelectorOption(payload.defaultBranchId, payload.defaultBranchName);
            updateTabLinks(payload.defaultBranchId);
          }
        });
      });

    $(document)
      .off('click.parcelClient')
      .on('click.parcelClient', '.js-client-search-trigger', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const $btn = $(this);
        const filterId = $btn.data('filter-id');
        const $dropdown = $('#' + filterId + '-client-dropdown');
        const $caret = $btn.find('.client-caret');

        if ($dropdown.is(':visible')) {
          closeClientDropdowns();
          return;
        }

        closeClientDropdowns();

        $dropdown.show();
        $caret.removeClass('fa-caret-down').addClass('fa-caret-up');

        // select2 needs a laid out dropdownParent, so it can attach only once the dropdown is visible
        Widgets.init($dropdown);
      });

    $(document)
      .off('click.parcelClientAdd')
      .on('click.parcelClientAdd', '.js-client-add', function () {
        const $dropdown = $(this).closest('.client-search-dropdown');
        const filterId = $dropdown.attr('id').replace('-client-dropdown', '');
        const $select = $('#' + filterId + '-client-select');

        const selected = $select.select2('data')[0];
        if (!selected || !selected.id) return;

        const clients = clientsByFilter[filterId] || (clientsByFilter[filterId] = []);

        if (!clients.find((c) => String(c.id) === String(selected.id))) {
          clients.push({ id: selected.id, text: selected.text });
          $('.js-client-search-trigger[data-filter-id="' + filterId + '"]')
            .closest('.parcel-type-filter')
            .find('[data-is-all="1"]')
            .prop('checked', false);
          renderSelectedClients(filterId);
        }

        $select.val('').trigger('change');
      });

    $(document)
      .off('click.parcelClientClose')
      .on('click.parcelClientClose', '.js-client-close', closeClientDropdowns);

    $(document)
      .off('click.parcelClientRemove')
      .on('click.parcelClientRemove', '.remove-client', function () {
        const clientId = String($(this).data('client-id'));
        const filterId = $(this)
          .closest('.selected-clients-container')
          .attr('id')
          .replace('-selected-clients', '');

        clientsByFilter[filterId] = (clientsByFilter[filterId] || [])
          .filter((c) => String(c.id) !== clientId);

        renderSelectedClients(filterId);
      });

    $(document)
      .off('click.parcelOutside')
      .on('click.parcelOutside', function (e) {
        if (!$(e.target).closest('.parcel-type-filter-wrapper').length) {
          closeClientDropdowns();
        }
      });

    $(document)
      .off('change.parcelTypeFilter')
      .on('change.parcelTypeFilter', '.parcel-type-checkbox', function () {
        const $checkbox = $(this);
        const $group = $checkbox.closest('.parcel-type-filter');
        const isAll = $checkbox.attr('data-is-all') === '1';
        const $allCheckbox = $group.find('[data-is-all="1"]');
        const $otherCheckboxes = $group.find('[data-is-all="0"]');
        const filterId = $group.find('.js-client-search-trigger').data('filter-id');
        const checked = $checkbox.prop('checked');

        if (isAll && checked) {
          $otherCheckboxes.prop('checked', false);
          clientsByFilter[filterId] = [];
          renderSelectedClients(filterId);
          return;
        }

        if (!isAll && checked) {
          $allCheckbox.prop('checked', false);
          return;
        }

        if (!isAll && !checked) {
          if ($checkbox.hasClass('client-type-checkbox')) {
            clientsByFilter[filterId] = [];
            renderSelectedClients(filterId);
          }

          if ($otherCheckboxes.filter(':checked').length === 0) {
            $allCheckbox.prop('checked', true);
          }
        }
      });
  });

  if (typeof $.nette === 'undefined' || !$.nette.ext) return;
  if (window.__parcelNetteExtInitialized) return;
  window.__parcelNetteExtInitialized = true;

  $.nette.ext('parcel-block-refresh-state', {
    before: function (xhr, settings) {
      return !(isParcelPage() && settings.url && settings.url.includes('refreshState'));
    },
  });

  $.nette.ext('parcel-datagrid-reinit', {
    success: function (payload) {
      if (!isParcelPage()) return;

      if (payload.resetBranch && payload.defaultBranchId) {
        setBranchSelectorOption(payload.defaultBranchId, payload.defaultBranchName);
      }
    },
  });

  $.nette.ext('parcel-dropdown-reinit', {
    success: function () {
      if (!isParcelPage()) return;
      initBootstrapComponents();
    },
  });
})();

function closeClientDropdowns() {
  $('.client-search-dropdown').hide();
  $('.client-caret').removeClass('fa-caret-up').addClass('fa-caret-down');
}

const GROUP_MODALS = [
  { flag: 'openConfirmCloseModal', modal: 'confirmCloseModal', count: 'confirmCloseCount', key: 'closeIds' },
  { flag: 'openConfirmValidModal', modal: 'confirmValidModal', count: 'confirmValidCount', key: 'validIds' },
];

const selection = { closeIds: [], validIds: [] };

function submitFromModal({ $button, modal, icon, data, keepGridState = false, onSuccess }) {
  const $icon = $button.find('i');

  $button.prop('disabled', true);
  $icon.removeClass(icon).addClass('fa-spinner fa-spin');
  $.addDatagridSpinner($grid());

  const url = $button.data('url');

  $.nette.ajax({
    method: 'POST',
    url:    keepGridState ? gridSignalUrl(url) : url,
    data:   data,
    success: function (payload) {
      if (!payload.success) {
        showToast('error', t.error, payload.message);
        return;
      }

      Modals.hide(modal);
      showToast('success', t.success, payload.message);

      if (onSuccess) {
        onSuccess(payload);
      }
    },
    error: function () {
      showToast('error', t.error, t.connectionFailed);
    },
    complete: function () {
      $.removeDatagridSpinner();
      $button.prop('disabled', false);
      $icon.removeClass('fa-spinner fa-spin').addClass(icon);
    },
  });
}

function markRowsValidated(parcelIds) {
  parcelIds.forEach((id) => {
    const $row = $('tr[data-id="' + id + '"]');

    $row.find('.col-inspected_by i')
      .attr('class', 'fas fa-check-circle text-success fa-2x')
      .attr('aria-label', 'OK')
      .attr('data-bs-original-title', 'OK');
    $row.find('.col-checkbox input').prop('disabled', true).closest('td').empty();
  });
}

$(function () {
  if (!isParcelPage()) return;

  $.nette.ext('parcel-group-modals', {
    success: function (payload) {
      GROUP_MODALS.forEach((group) => {
        if (!payload[group.flag]) return;

        selection[group.key] = payload.parcelIds ?? [];
        $('#' + group.count).text(selection[group.key].length);
        Modals.show(group.modal);
      });
    },
  });

  $.nette.ext('parcel-manual-send-modal', {
    success: function (payload) {
      if (!payload.openManualSendModal) return;

      const $row = $('tr[data-id="' + payload.parcelId + '"]');
      const now = new Date();

      $('#parcelId').val(payload.parcelId);
      $('#parcelNumber').text($row.find('.col-barcode').text().trim());
      $('#parcelRecipient').text($row.find('.col-recipient').text().trim());
      $('#sendDate').val(localDateValue(now));
      $('#sendTime').val(localTimeValue(now));
      $('#trackingCode').val('');
      $('#sendNote').val('');

      Modals.show('manualSendModal');
    },
  });

  $('#confirmValidSubmit').off('click').on('click', function () {
    submitFromModal({
      $button: $(this),
      modal:   'confirmValidModal',
      icon:    'fa-check',
      data:    { parcelIds: selection.validIds },
      onSuccess: function () {
        markRowsValidated(selection.validIds);
        selection.validIds = [];
      },
    });
  });

  $('#confirmCloseSubmit').off('click').on('click', function () {
    submitFromModal({
      $button:       $(this),
      modal:         'confirmCloseModal',
      icon:          'fa-lock',
      data:          { parcelIds: selection.closeIds },
      keepGridState: true,
      onSuccess: function () {
        selection.closeIds = [];
        setTimeout(function () {
          restoreClientFilter();
          initializeFilters();
        }, 100);
      },
    });
  });

  $('#confirmManualSend').off('click').on('click', function () {
    const sendDate = $('#sendDate').val();
    const sendTime = $('#sendTime').val();

    if (!sendDate || !sendTime) {
      showToast('error', t.error, t.fillDateTime);
      return;
    }

    submitFromModal({
      $button:       $(this),
      modal:         'manualSendModal',
      icon:          'fa-lock',
      keepGridState: true,
      data: {
        parcelId:     $('#parcelId').val(),
        sendDate:     sendDate,
        sendTime:     sendTime,
        trackingCode: $('#trackingCode').val(),
        note:         $('#sendNote').val(),
      },
    });
  });

  $(document).on('click', '.datagrid tbody tr.has-detail', function (e) {
    // the controls handle their own click, the detail toggle included - re-triggering it sends the signal twice
    if ($(e.target).closest('a, button, input, select, .dropdown').length > 0) {
      return;
    }

    $(this).find('a[data-toggle-detail]').first().trigger('click');
  });
});
